import { useState } from 'react';

export function useNotes(defaultNote) {
    const [value, setValue] = useState(defaultNote);

    function onChange(e) {
        console.log(e.target.value);
        setValue(e.target.value);
    }

    return {
        value,
        onChange,
        setValue,
    };
}
